const steps = [
  {
    number: '01',
    icon: 'ri-phone-line',
    title: 'Contact Us & Get a Quote',
    desc: 'Call or fill out our quick online form. We\'ll discuss your move date, items, locations, and any special requirements. You\'ll receive a clear, upfront estimate with no hidden fees.',
    color: 'from-orange-500 to-red-500',
  },
  {
    number: '02',
    icon: 'ri-calendar-check-line',
    title: 'Schedule & Confirm',
    desc: 'We lock in your move date and assign a dedicated crew. You\'ll get a confirmation with crew details, arrival window, and a checklist to help you prepare for moving day.',
    color: 'from-amber-500 to-orange-500',
  },
  {
    number: '03',
    icon: 'ri-archive-2-line',
    title: 'Professional Packing',
    desc: 'On packing day, our team arrives with all materials. Every fragile item is wrapped, every box labeled, and every piece of furniture protected with moving blankets and pads.',
    color: 'from-emerald-500 to-teal-500',
  },
  {
    number: '04',
    icon: 'ri-truck-line',
    title: 'Loading & Transport',
    desc: 'Our crew loads everything onto our fully-equipped truck using the correct technique for each item. We drive safely and efficiently to your new location — keeping you updated throughout.',
    color: 'from-sky-500 to-cyan-500',
  },
  {
    number: '05',
    icon: 'ri-home-smile-line',
    title: 'Unload & Set Up',
    desc: 'We unload everything carefully at your new home or office, placing furniture exactly where you want it. We reassemble what was disassembled and take all packing materials away.',
    color: 'from-violet-500 to-purple-500',
  },
];

export default function MovingProcess() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block bg-orange-100 text-orange-600 text-sm font-bold px-4 py-2 rounded-full mb-4">
            How It Works
          </span>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 mb-4">
            Our Simple 5-Step Moving Process
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto text-lg">
            We&apos;ve refined our moving process over 20+ years so every step is smooth, predictable, and stress-free for you.
          </p>
        </div>

        {/* Process image + steps */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center mb-16">
          <div className="relative">
            <img
              src="https://public.readdy.ai/ai/img_res/a459cf8fe65d4fe965430a61ec96534a.jpg"
              alt="City to City Moving Company crew carefully wrapping furniture for transport"
              className="w-full rounded-3xl object-cover object-top"
              style={{ height: '420px' }}
            />
            <div className="absolute -bottom-5 -right-5 bg-gradient-to-br from-orange-500 to-red-500 text-white rounded-2xl p-5">
              <div className="text-3xl font-black">5,000+</div>
              <div className="text-sm font-semibold opacity-90">Moves Completed</div>
            </div>
          </div>

          <div className="space-y-5">
            {steps.map((step) => (
              <div key={step.number} className="flex gap-5 group">
                <div className={`w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-2xl bg-gradient-to-br ${step.color} group-hover:scale-110 transition-transform`}>
                  <i className={`${step.icon} text-2xl text-white`}></i>
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-1">
                    <span className={`text-xs font-black bg-gradient-to-r ${step.color} bg-clip-text text-transparent`}
                      style={{ WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
                      STEP {step.number}
                    </span>
                  </div>
                  <h3 className="font-black text-slate-900 mb-1">{step.title}</h3>
                  <p className="text-slate-600 text-sm leading-relaxed">{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
